export default __webpack_public_path__ + "static/media/unavsaThree.2aca3127.png";